<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <salary-group-create-or-update v-model="group" :errors="errors"></salary-group-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :disabled="!canSave" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :fields="fields"
                    :add-callback="createNew"
                    search
                    pagination="server"
                    :items-provider="provider"
                    :buttons="buttons"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue';
import EmployeeOperationsApi from '@/api/employee-operations'
import SalaryGroupCreateOrUpdate from './components/SalaryGroupCreateOrUpdate.vue';

export default {
    components:{
        BCard,
        SalaryGroupCreateOrUpdate
    },
    data(){
        return {
            fields:[
                {name:"Kod",key:"Code",thClass:'w-50'},
                {name:"Ad",key:"Name",thClass:'w-50'},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            errors:{},
            loading:false,
            editing:false,
            group:{
                Id:null,
                Code:null,
                Name:null,
                Branches:[
                    {Branch:null,CollarStatus:[]}
                ],
                ExcludedBranches:[]
            }
        }
    },
    methods:{
        provider(data){
            return EmployeeOperationsApi.SalaryGroup.Table(data)
        },
        clearForm(){
            this.editing = false
            this.group.Id = null
            this.group.Code = null
            this.group.Name = null
            this.group.Branches = [
                {Branch:null,CollarStatus:[]}
            ]
            this.group.ExcludedBranches = [] 
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.group.Id = item.Id
            this.group.Code = item.Code
            this.group.Name = item.Name
            this.group.Branches = item.Branches.map(b => ({
                Branch:{Id:b.BranchId,Name:b.BranchName},
                CollarStatus:(b.CollarStatuses || [])?.map(c => ({
                    Id:c.Key,
                    Name:c.Value
                }))
            }))
            this.group.ExcludedBranches = item.ExcludedBranches.map(b => ({
                Branch:{Id:b.BranchId,Name:b.BranchName},
                CollarStatus:(b.CollarStatuses || [])?.map(c => ({
                    Id:c.Key,
                    Name:c.Value
                }))
            }))
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            let data = structuredClone(this.group)
            data.Branches = data.Branches.map(b => ({
                BranchId:b.Branch?.Id,
                CollarStatusIds:b.CollarStatus?.map(c => c.Id || null).filter(c => c != null)
            }))
            data.ExcludedBranches = data.ExcludedBranches.map(b => ({
                BranchId:b.Branch?.Id,
                CollarStatusIds:b.CollarStatus?.map(c => c.Id || null).filter(c => c != null)
            }))
            EmployeeOperationsApi.SalaryGroup.CreateOrUpdate(this.editing,data).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} ödeme grubunu silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    EmployeeOperationsApi.SalaryGroup.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    },
    computed:{
        canSave(){
            return this.group.Branches.every(b => b.Branch != null && (b.CollarStatus || []).length != 0) && (this.group.ExcludedBranches.length > 0 ? this.group.ExcludedBranches .every(b => b.Branch != null && (b.CollarStatus || []).length != 0) : true)
        }
    }
}
</script>